import { useState, useEffect } from 'react'
import BlockCart from './BlockCart'
import Header from './Header'
import Footer from './Footer'
import ProductosRecomendados from './ProductosRecomendados'


const DetalleProducto = ({user,removeProduct,subTotal,miproductos,expressActive,changeHasExpress,changeMethodShopping,methodShopping,loadMenu,loadTransversal,transversal,menus,myLazyLoad,myListCart,handleMiproductos,handleSubTotal}) =>{
//	window.detailpath = "platano-seda";

	const [detalle, setDetalle ] = useState([])
	const [cantidad,setCantidad] = useState(0)

	const getApiData = async () => {
		
			const dataq = new FormData();
			dataq.append("id_comercio", localStorage.comercioId );
			dataq.append("id_backoffice", window.detailpath );
	 		if (localStorage.methodshopping === "express" ) {
				dataq.append("is_express", "1" );
			}else{
			    dataq.append("is_express", "0" );
			}
			const response = await fetch(window.path_service+"/api/producto/detail/raw",{method:'POST',body: dataq})
			const data = await response.json()
	       
	       if (data.status) {
	       	//window.detalle = data.data;
	        	setDetalle(data.data)
	        	setCantidad(data.data.cantidad_inicial)
	        }
	};

	//const detalle = window.detailpro
	
    useEffect(() => {
    	getApiData();
    	if ( typeof fbq !== "undefined" ) { 
			window.fbq('track', 'ViewContent',{
			    content_type: 'product',
			    content_ids: detalle.sku
			});    
    	}
    }, [methodShopping]);



   const handleAumentarCantidad = (cant) => {
      setCantidad(cant)
   }

  	const shopShareFb= () => {
  		window.open('http://www.facebook.com/sharer/sharer.php?u='+window.location.href, 'facebook_share', 'height=320, width=640, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');
	}
	const shareWhatsapp =() =>{
		window.open("https://api.whatsapp.com/send?text="+encodeURI(detalle.name+":: "+window.location.href) );
	}


    const handleAddCard = async () => {
        let distritoPay = parseInt(localStorage.distritoPay);
        if ( !isNaN(distritoPay) ) {

            if ( window.getCookie("commerce_lead_token") !== "" && window.getCookie("commerce_lead_token") !== undefined ) {
              var myHeaders = new Headers();
              myHeaders.append("Authorization", "Bearer "+ window.getCookie("commerce_lead_token") );              

              const dataq = new FormData();
              dataq.append("type", "add" );
              dataq.append("action", "shop_add_cart" );
              dataq.append("id_producto", detalle.id );
              dataq.append("cantidad", cantidad );
				if (localStorage.methodshopping === "express" ) {
					dataq.append("is_express", "1" );
				}else{
				    dataq.append("is_express", "0" );
				}              
             const response = await fetch(window.path_service+"/api/add-cart",{method:'POST',body: dataq , headers: myHeaders })
             const data = await response.json()

             if (data.status) {

                if ( typeof fbq !== "undefined" ) { 
					window.fbq('track', 'AddToCart',{
					    content_type: 'product',
					    content_ids: detalle.sku
					});
                }

                if ( typeof AddToCart !== "undefined" ) { 
                  //window.AddToCart(detalle.sku,cantidad);
                } 
                
             }

            }else{
              let ecart = JSON.parse(localStorage.getItem('my_shopping_car'));
              if( [null,"null",undefined,"undefined"].includes(localStorage.getItem('my_shopping_car')) ){
                 ecart = [];
              }
              
              let quantity_fin = detalle.cantidad_inicial
              const existProduct = ecart.map(function(item){ return item['id']; }).indexOf( detalle.id );

              if( existProduct === -1 ){
                 ecart.push({
                    id: detalle.id,
                    quantity:parseFloat(cantidad)
                 });

              }else{
                 quantity_fin =  parseFloat(ecart[existProduct].quantity) + parseFloat(cantidad);
                 ecart[existProduct].quantity = quantity_fin;
              }

              localStorage.setItem('my_shopping_car', JSON.stringify(ecart) );
              //list_shopping_cart();      

            }
            //EFECTO ADD TO CART
            const cart = window.$('#cartList');
            const imgtodrag = window.$('#'+detalle.sku);

            if (imgtodrag) {
              const imgclone = imgtodrag.clone()
                        .offset({
                        top: imgtodrag.offset().top,
                        left: imgtodrag.offset().left
                    }).css({
                        'opacity': '0.5',
                            'position': 'absolute',
                            'height': '150px',
                            'width': '150px',
                            'z-index': '100'
                    })
                        .appendTo(window.$('body'))
                        .animate({
                        'top': cart.offset().top + 10,
                            'left': cart.offset().left + 10,
                            'width': 75,
                            'height': 75
                    }, 1000);
                    

                    imgclone.animate({
                        'width': 0,
                            'height': 0
                    }, function () {
                        window.$(this).detach()
                    });
                }
                //EFECTO ADD TO CART

            myListCart()

        }else{
            window.$("#modalSelectionDistrito").modal("show")
        }
   };

	return (
	    <div>
	        <Header
	        user = {user}
	        myLazyLoad = {myLazyLoad}
	        	loadMenu = {loadMenu}
	        	loadTransversal = {loadTransversal}
	        	menus = {menus}
	        	transversal = {transversal}
	        	changeHasExpress = {changeHasExpress}
	        	changeMethodShopping = {changeMethodShopping}
	        	methodShopping = {methodShopping}
	        	expressActive = {expressActive}
		        subTotal = {subTotal}
		        miproductos = {miproductos}
		        list_cart = {myListCart}
		        handleMiproductos = {handleMiproductos}
		        handleSubTotal = {handleSubTotal}
		        removeProduct = {removeProduct}
	        />


		<main  className="wrap-content page-interna">
		  <div className="container-interna ms-product ms-step-detail-product">
		  	
		   <div className="ms-section">
			  	<div className="breadcrumb-outer">
			  		<div className="breadcrumb-wrap">
			  			{
			  				"code_categoria_secundaria" in detalle !== '0' ? 
				  			<div className="breadcrumb-inner ruby-container">
				  				<span><a href="/"><span>Inicio</span></a></span>
				  				<i className="fa fa-angle-right breadcrumb-next"></i>
						  		<span><a href={detalle.main_path_cat}><span>{detalle.main_name_cat}</span></a></span>
						  		<i className="fa fa-angle-right breadcrumb-next"></i>
						  		<span><a href={detalle.submain_path_cat}><span>{detalle.submain_name_cat}</span></a></span>	  				
				  				<i className="fa fa-angle-right breadcrumb-next"></i>
				  				<span className="breadcrumb-current">{detalle.name}</span>
				  			</div>
			  				:
				  			<div className="breadcrumb-inner ruby-container">
				  				<span><a href="/"><span>Inicio</span></a></span>
				  				<i className="fa fa-angle-right breadcrumb-next"></i>
						  		<span><a href={detalle.main_path_cat}><span>{detalle.main_name_cat}</span></a></span>
						  		<i className="fa fa-angle-right breadcrumb-next"></i>
				  				<span className="breadcrumb-current">{detalle.name}</span>
				  			</div>			  				
			  			}

			  		</div>
			  	</div>

		      <div className="ms-wizard-wrapper">
			      <div className="ms-lateral-a">
			      	<div className="ms-detail-product ms-wizard-item">

		                  { 
		                    detalle.tiene_descuento === 1 && detalle.mensaje_oferta !== "" && detalle.mensaje_oferta !== null ? 
		                        <div className="detail-block-offert">
		                        	<div className="ms-offert-long">{detalle.mensaje_oferta}</div>
		                        </div>
		                    :
		                    null
		                  }
		                  
			      		<div className="detail-gallery">
			      			<img src={detalle.image} id={detalle.sku} className="img-product-detail" alt={detalle.name} />
			      		</div>

			      		<div className="content-product">
			      			<div className="product-title">
			      				<h3>{detalle.name}</h3>
			      			</div>

			      			{
			      				detalle.tiene_descuento === 1 ?
			      					<div className="product-price">
					      				<span className="price-old">S/. { "price" in detalle ? detalle.price.toFixed(2)  : null }</span> <span className="price-oferta">S/. { "nuevo_precio" in detalle ? detalle.nuevo_precio.toFixed(2)  : null } </span> 
					      				<span>{detalle.unidad_medida}</span>
				      				</div>
			      				:
			      					<div className="product-price">
				      					<span className="price-oferta">S/. { 
				      						"price" in detalle ?
				      						detalle.price.toFixed(2) 
				      						:
				      						null
				      					}</span>
				      					<span className="prod-unidad">{detalle.unidad_medida}</span>
				      				</div>
			      			}

			      			<div className="eko-block-add-cart">
			      				{
			      					detalle.status_service === 1 ?
					      				<div className="margin-qty">
						                     <BlockCart 
						                     methodShopping = {methodShopping}
						                     prod = {detalle}
						                     handleAumentarCantidad = {handleAumentarCantidad}
						                     />						      				
							                <span className="prod-unidad">{detalle.unidad_medida}</span>
					      				</div>

			      					:
			      					null
			      				}

			      				{
			      					detalle.status_service === 1 ?
						                <div className="js-eko-add-cart" onClick={handleAddCard}>
						                	<button type="submit" className="shop-button  js-add-cart-block">Agregar al carrito</button>
						                </div>			      					:
			      					null
			      				}

			      				{
			      					detalle.status_service === 0 ?
					      				<div className="js-eko-add-cart disabled">
				                          <button disabled="" type="submit" className="shop-button  js-add-cart-block">NO DISPONIBLE</button>
				                       	</div>
			      					:
			      					null
			      				}

			      				{
			      					detalle.status_service === 2 ?
					      				<div className="js-eko-add-cart disabled">
				                          <button disabled="" type="submit" className="shop-button  js-add-cart-block">No Disponible</button>
				                       	</div>		
			      					:
			      					null
			      				}
		                  	</div>
		                  	<div className="shared"><div className="compartirText">Compartir: </div><div role="button" onClick={shopShareFb} className="SocialMediaShareButton SocialMediaShareButton--facebook shared-btn shared-fb"><div style={{"width": "32px", height: "32px"}}><svg viewBox="0 0 64 64" width="32" height="32" className="social-icon social-icon--facebook "><g><circle cx="32" cy="32" r="31" fill="#3b5998"></circle></g><g><path d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z" fill="white"></path></g></svg></div></div>
		                  	<div role="button" onClick={shareWhatsapp} className="SocialMediaShareButton SocialMediaShareButton--whatsapp shared-btn shared-wa"><div style={{"width": "32px", "height": "32px"}}><svg viewBox="0 0 64 64" width="32" height="32" className="social-icon social-icon--whatsapp "><g><circle cx="32" cy="32" r="31" fill="#2cb742"></circle></g><g><path d="m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915" fill="white"></path></g></svg></div></div></div>
			      		</div>
			      	</div>

			        {
			        	detalle.description !== "" ?
					        <div className="ms-wizard-item ms-product-description">
					          <div className="product-content">
					            <p dangerouslySetInnerHTML={{ __html: detalle.description }} />
					          </div>
					        </div>
			        	: null
			        }
			      
			      </div>
			  

			      <div className="ms-lateral-b ms-despacho">
			        <div className="ms-wizard-item">
			          <div className="ms-wrap-item">
			            <div className="ms-table-item" style={{"marginBottom": "0"}}>
			              <div className="ms-icon-block">
			                <i className="fa fa-lock" aria-hidden="true"></i>
			                <span>PAGO SEGURO</span>
			              </div>
			              <p className="ms-small-text">Aceptamos pagos con tarjetas de crédito Visa, MasterCard, American Express y Dinners Club.</p>
			            </div>
			          </div>
			        </div>
			      </div>

		      </div>
		   </div>
		  </div>


			{
				"sku" in detalle ? 

				        	<ProductosRecomendados
				        		list_cart = {myListCart}
				        		titleProd = {detalle.name}
				        		product_id = {detalle.code_backoffice}
				        		id_subcategoria = {detalle.code_categoria_secundaria}
				        		palabras_claves = {detalle.palabras_claves}
					        	limit = "10"
					        	title = "PRODUCTOS RELACIONADOS"
					        	methodShopping = {methodShopping}
				        	 />
				:
				null
			}


		</main>

		<Footer />


	    </div>

	)
}

export default DetalleProducto;